<button
  type="button"
  class="trigger"
  cdkOverlayOrigin
  data-topbar-trigger="bell"
  #origin="cdkOverlayOrigin"
  (click)="toggle()"
  [attr.aria-expanded]="open()"
  aria-haspopup="menu"
  [attr.aria-label]="'nav.topbar.notifications' | translate"
  data-testid="notifications-btn"
>
  <mat-icon class="bell">notifications</mat-icon>
  <!-- Accent badge, never red; counts UNSEEN and clears when the panel opens.
       Entry pop + one-shot growth pulse; both sit out prefers-reduced-motion. -->
  @if (unseenCount() > 0 && !open()) {
    <span
      class="badge"
      [class.bump]="bump()"
      (animationend)="bump.set(false)"
      data-testid="notifications-badge"
      >{{ badgeLabel() }}</span
    >
  }
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 6 }
  ]"
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="onBackdropClick($event)"
  (detach)="onDetach()"
>
  <div class="popover" data-testid="notifications-panel">
    <div class="head">
      <span class="head-title">{{ 'nav.topbar.notifications' | translate }}</span>
      @if (!isEmpty()) {
        <button type="button" class="head-action" (click)="markAllRead()">
          {{ 'nav.topbar.mark_all_read' | translate }}
        </button>
      }
    </div>

    @if (isEmpty()) {
      <div class="empty">
        <div class="empty-icon"><mat-icon class="bell">notifications</mat-icon></div>
        <div class="empty-title">{{ 'nav.topbar.notifications_empty_title' | translate }}</div>
        <div class="empty-body">{{ 'nav.topbar.notifications_empty_body' | translate }}</div>
      </div>
    } @else {
      <div class="list">
        @for (group of [
          { key: 'today', label: 'nav.topbar.notifications_today', rows: todayRows() },
          { key: 'earlier', label: 'nav.topbar.notifications_earlier', rows: earlierRows() }
        ]; track group.key) {
          @if (group.rows.length) {
            <div class="caption">{{ group.label | translate }}</div>
            @for (row of group.rows; track row.id) {
              <button type="button" class="row" [class.unread]="row.unread" (click)="openRow(row)">
                <span class="row-icon"><mat-icon>{{ iconFor(row.kind) }}</mat-icon></span>
                <span class="row-body">
                  <span class="row-top">
                    <span class="row-title">{{ row.title }}</span>
                    @if (row.unread) {
                      <span class="dot"></span>
                    }
                    <span class="row-time">{{ row.time }}</span>
                  </span>
                  <span class="row-meta">{{ row.meta }}</span>
                </span>
              </button>
            }
          }
        }
      </div>
    }

    <button type="button" class="footer" data-testid="open-action-hub" (click)="openActionHub()">
      {{ 'nav.topbar.open_action_hub' | translate }}
      <mat-icon class="footer-icon">arrow_forward</mat-icon>
    </button>
  </div>
</ng-template>
